import { Directive, Output, EventEmitter, ElementRef, HostListener } from '@angular/core';

@Directive({
	selector: '[lbClickOutside]',
	standalone: true
})
export class ClickOutsideDirective {
	@Output() clickOutside = new EventEmitter<MouseEvent>();

	constructor(private elementRef: ElementRef) {}

	@HostListener('document:click', ['$event'])
	onDocumentClick(event: MouseEvent): void {
		const target = event.target as HTMLElement;
		if (
			target &&
			!this.elementRef.nativeElement.contains(target) &&
			!target.classList.contains('option') &&
			!target.classList.contains('option-template') &&
			!target.classList.contains('option-label') &&
			!target.classList.contains('day') &&
			!target.classList.contains('week') &&
			!target.classList.contains('month') &&
			!target.classList.contains('year') &&
			target.parentElement?.tagName !== 'BUTTON' &&
			!target.innerHTML.includes('hs-web-interactives-top-push-anchor')
		) {
			this.clickOutside.emit(event);
		}
	}
}
